type Cell = string | number | null | undefined;

function escapeCell(v: Cell, sep: string): string {
  const s = v == null ? '' : String(v);
  return s.includes(sep) || s.includes('"') || s.includes('\n')
    ? `"${s.replace(/"/g, '""')}"`
    : s;
}

export function downloadCsv(filename: string, headers: string[], rows: Cell[][]) {
  const sep = ';'; // Excel BR usa ponto-e-vírgula
  const lines = [headers, ...rows].map((row) => row.map((c) => escapeCell(c, sep)).join(sep));
  const bom  = '﻿';
  const blob = new Blob([bom + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
